import { useMemo } from 'react';

import { getGuideUrl } from '@change-corgi/config/guides';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useGuideLinks(): LinkGroup | null {
	const locale = useLocale();

	return useMemo(
		() =>
			locale === 'en-US'
				? processLinkGroup({
						title: 'Guides',
						links: [
							{ href: getGuideUrl(locale, 'home'), title: 'Petition Guides' },
							{ href: getGuideUrl(locale, 'createPetition'), title: 'Create Your Petition' },
							{ href: getGuideUrl(locale, 'sharePetition'), title: 'Collect Signatures' },
							{ href: getGuideUrl(locale, 'reachMedia'), title: 'Reach out to Media' },
							{ href: getGuideUrl(locale, 'engageDecisionMaker'), title: 'Engage Your Decision Maker' },
						],
					})
				: null,
		[locale],
	);
}
